/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('department');
const DEPARTMENT_LIST = "DEPARTMENT_LIST";
const DEPARTMENT_ADD = "DEPARTMENT_ADD";
const DEPARTMENT_DELETE = "DEPARTMENT_DELETE";
const DEPARTMENT_EDIT = "DEPARTMENT_EDIT";
const DEPARTMENT_DETAIL = "DEPARTMENT_DETAIL";

export default {
    DEPARTMENT_LIST,
    departmentList : (search)=>{
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:DEPARTMENT_LIST,
                data
            })
        })
    },
    DEPARTMENT_ADD,
    departmentAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:DEPARTMENT_ADD,
                data
            })
        })
    },
    DEPARTMENT_DELETE,
    departmentDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:DEPARTMENT_DELETE,
                data,
            })
        })
    },
    DEPARTMENT_EDIT,
    departmentEdit:(id,info)=>{
        info = Object.assign({}, info);
        delete info.admin;
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:DEPARTMENT_EDIT,
                data,
            })
        })
    },
    DEPARTMENT_DETAIL,
    departmentDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:DEPARTMENT_DETAIL,
                data,
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/DepartmentAction.js